import React from "react";
import "./View_img_Modal.css";
import { Modal } from "react-bootstrap";
import { IDS } from "../../../../utils/IDS";

function View_img_Modal({ ...props }) {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_img_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            View Document
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="img_holder">
            <img
              src={`${IDS.IMG_URL}${props?.image}`}
              alt={"doc"}
              className="view_documents_img"
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default View_img_Modal;
